import { useCallback } from 'react';
import useUserInfo from './useUserInfo';
import { useLocation } from 'react-router';
import { scheduleCall } from '../components/dashboard/customerSupportHelper';
import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../reducers/userInfoReducer';

const useBookDemoClickHandler = () => {
  const userInfo = useSelector(selectUserInfoData);
  const { updateHubspotContact } = useUserInfo();
  const { pathname } = useLocation();
  const mainPath = pathname.split('/')[1];

  const bookDemoClickHandler = useCallback(() => {
    updateHubspotContact({
      last_demo_click_source: mainPath,
      last_demo_click_date: Date.now(),
    });
    scheduleCall(userInfo);
  }, [mainPath, updateHubspotContact, userInfo]);

  return bookDemoClickHandler;
};

export default useBookDemoClickHandler;
